import React from 'react';
import { LazySection } from './LazySection';
export function Upsell() {
  return <LazySection className="bg-cream-dark !py-[80px] md:!py-[100px]" data-id="element-379">
      <div className="container-wide" data-id="element-380">
        <h2 className="text-center text-[clamp(28px,4vw,40px)] mb-3" data-id="element-381">
          ¿Qué suma el <span className="text-gold-dark" data-id="element-382">Sistema Completo</span>{' '}
          sobre el Esencial?
        </h2>
        <p className="text-center text-ink-soft text-[16px] max-w-[660px] mx-auto mb-[50px]" data-id="element-383">
          No son "más cosas". Son los módulos que se activan cuando el proceso
          toca fondo — justo donde la mayoría se traba.
        </p>

        <div className="max-w-[900px] mx-auto bg-white rounded-[16px] overflow-hidden border border-border shadow-soft" data-id="element-384">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr_1fr] bg-ink text-cream border-b border-border" data-id="element-385">
            <div className="p-4 md:px-5 md:py-4 font-serif font-medium text-[15px]" data-id="element-386">
              Cuando aparece…
            </div>
            <div className="p-4 md:px-5 md:py-4 font-serif font-medium text-[15px] text-red-x hidden md:block" data-id="element-387">
              Solo con Esencial
            </div>
            <div className="p-4 md:px-5 md:py-4 font-serif font-medium text-[15px] text-gold-light hidden md:block" data-id="element-388">
              Con Sistema Completo
            </div>
          </div>

          {/* Rows */}
          {[{
          sit: 'Rabia o resentimiento con tu madre',
          theirs: 'Lo trabajás sola, con lo que aparezca',
          ours: 'Módulo Protocolo de Linaje Materno — proceso guiado paso a paso'
        }, {
          sit: 'Culpa cuando te va bien o recibís algo',
          theirs: 'Identificás el patrón pero no el mandato paterno',
          ours: 'Módulo Protocolo de Linaje Paterno — específico para el mandato del merecimiento'
        }, {
          sit: 'Emociones intensas que aparecen "de golpe"',
          theirs: 'Las gestionás como puedas',
          ours: 'Protocolos de protección + meditaciones guiadas'
        }, {
          sit: 'La voz crítica interna no para',
          theirs: 'Seguís luchando con ella',
          ours: 'Módulo Protocolo de la Voz Crítica — la raíz pre-verbal de esa voz'
        }, {
          sit: 'Necesitás sostener el cambio meses después',
          theirs: 'Sin seguimiento estructurado',
          ours: 'Diario guiado de 12 meses — un prompt por día'
        }].map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr_1fr] border-b border-border last:border-0" data-id="element-389">
              <div className="p-4 md:px-5 md:py-5 font-serif font-medium text-[15px] text-ink md:border-r border-border flex items-center bg-cream/30 md:bg-transparent" data-id="element-390">
                {row.sit}
              </div>
              <div className="p-4 md:px-5 md:py-5 text-[14px] leading-[1.5] text-ink-soft italic md:border-r border-border flex items-center border-b border-black/5 md:border-b-0" data-id="element-391">
                <span className="md:hidden font-semibold mr-2 not-italic text-red-x" data-id="element-392">
                  Esencial:
                </span>{' '}
                {row.theirs}
              </div>
              <div className="p-4 md:px-5 md:py-5 text-[14px] leading-[1.5] text-ink font-medium flex items-center" data-id="element-393">
                <span className="md:hidden font-semibold mr-2 text-gold-dark" data-id="element-394">
                  Completo:
                </span>{' '}
                {row.ours}
              </div>
            </div>)}
        </div>
      </div>
    </LazySection>;
}